// Utility function to calculate distance between two lat/lon points in km or mi
function getDistance(lat1, lon1, lat2, lon2, unit = 'mi') {
  const R = unit === 'km' ? 6371 : 3958.8; // Radius of Earth in km or miles
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  console.log('Distance mi:', R * c);
  return R * c;
}
export default getDistance;
